import { RemaniningDays } from '../types';

export const HOME_ROUTE = '/';
export const APPLICATION_TEMPLATES = '/application-templates';
export const SURVEY_ROUTE = '/survey';
export const FROM_LINK_HOME_ROUTE = '/leaverequest/:id';
export const FROM_LINK_HISTORY_HOME_ROUTE = '/history/:id';
export const LOGIN_ROUTE = '/login';
export const SETTINGS_ROUTE = '/settings';
export const ACTING_ROUTE = '/acting-user';
export const CALENDAR_ROUTE = '/calendar';
export const REPORTS_ROUTE = '/reports';
export const REPORTS_DETAIL_ORG_ROUTE = '/reports/organization';
export const REPORTS_DETAIL_DEP_ROUTE = 'reports/department';
export const REPORTS_DETAIL_SECTOR_ROUTE = 'reports/sector';
export const REPORT_PROJECT = 'reports/projects';
export const PLANNER_ROUTE = '/planner';
export const HELP_ROUTE = '/help';
export const HELP_ROUTE_BY = '/help/belarus';
export const HELP_ROUTE_BG = '/help/bulgaria';
export const HELP_ROUTE_CZ = '/help/czechia';
export const HELP_ROUTE_KZ = '/help/kazakhstan';
export const HELP_ROUTE_PL = '/help/poland';
export const HELP_ROUTE_UA = '/help/ukraine';
export const HELP_ROUTE_GE = '/help/georgia';
export const HELP_ROUTE_LT = '/help/lithuania';
export const PROFILE_ROUTE = '/profile';
export const HR_PROFILE_ROUTE = '/profile/:id';

export const CREATE_LEAVE_REQUEST_ACCESS_CODE = 'home.leaves.create';

export const COUNTRIES = [
  { name: 'Belarus', link: HELP_ROUTE_BY },
  { name: 'Bulgaria', link: HELP_ROUTE_BG },
  { name: 'Poland', link: HELP_ROUTE_PL },
  { name: 'Ukraine', link: HELP_ROUTE_UA },
  { name: 'Kazakhstan', link: HELP_ROUTE_KZ },
  { name: 'Georgia', link: HELP_ROUTE_GE },
  { name: 'Lithuania', link: HELP_ROUTE_LT }
];

export const REMAINING_DAYS_INITIAL: RemaniningDays = {
  allowanceString: '',
  availableForNowWithoutTransfer: 0,
  usedInThisPeriod: 0,
  staticTranferDays: 0,
  allowance: 0,
  usedInTransferDays: 0,
  annualBalance: 0,
  available: 0,
  usedInFuturePeriod: 0,
  availableForNow: 0,
  compensatoryOffBalance: 0,
  countryName: '',
  periodString: '',
  periodType: 'START_YEAR',
  taken: 0,
  transfer: 0,
  userId: 0,
  possibleToEditCBalance: false,
  takencompensatoryOffBalance: 0,
  isPossibleToEditEmployeeBalance: false,
  isPossibleToViewEmployeeBalance: false,
  employeeAllowanceBalance: 0,
  employeeTransferDaysBalance: 0
};

export const INITIAL_FIELDS_FOR_LEAVE_REQUEST_FORMS = {
  comment: '',
  endDate: '',
  fileSize: 0,
  requestTypeId: 0,
  startDate: '',
  onDemand: {
    checked: false,
    disabled:  false,
  }
};

export const whatIsNewUrlConfluenceEN = 'https://confluence.ibagroup.eu/display/LMS/2022/12/29/What%27s+New';
export const whatIsNewUrlConfluenceBY = 'https://confluence.ibagroup.eu/pages/viewpage.action?pageId=96176885';


// export enum LeaveRequestTypeId {
//   VACATION = 2,
//   VACATION_ON_DEMAND = 95,
// }
